<template>
  <div>
    <b-modal id="modalEditOptionDef" ref="modalEditOptionDef" :title="$t('Option-def editModal')" hide-footer size="lg">
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.code" aria-describedby="inputFeedbackCode" :state="editItem.code > 0"/>
          <b-form-invalid-feedback id="inputFeedbackCode"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Space')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
            <b-form-input type="text" v-model="editItem.space" aria-describedby="inputFeedbackSpace" :state="editItem.space.length > 0"/>
              <b-input-group-append>
              <span id="tooltip">
                <b-img :src="questionImage"/>
              </span>
              <b-tooltip target="tooltip" triggers="hover">
                ( dhcp6 | vendor-opts-space ) or custom in case of Nested DHCPv6 Options
              </b-tooltip>
            </b-input-group-append>
            <b-form-invalid-feedback id="inputFeedbackSpace"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Record-types')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem['record-types']" aria-describedby="inputFeedbackRecordTypes" :state="editItem['record-types'].length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackRecordTypes"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Encapsulate')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.encapsulate"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Type editModal')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.type" :options="optionsType"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Array')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox v-model="editItem.array"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditOptionDef.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    isEdit: null,
    optionDef: null
  },
  data () {
    return {
      questionImage: require('@/assets/img/question.png'),
      optionsType: [
        {text: 'Binary', value: 'binary'},
        {text: 'Boolean', value: 'boolean'},
        {text: 'Empty', value: 'empty'},
        {text: 'Fqdn', value: 'fqdn'},
        {text: 'Ipv4-address', value: 'ipv4-address'},
        {text: 'Ipv6-address', value: 'ipv6-address'},
        {text: 'Ipv6-prefix', value: 'ipv6-prefix'},
        {text: 'Psid', value: 'psid'},
        {text: 'Record', value: 'record'},
        {text: 'String', value: 'string'},
        {text: 'Tuple', value: 'tuple'},
        {text: 'Uint8', value: 'uint8'},
        {text: 'Uint16', value: 'uint16'},
        {text: 'Uint32', value: 'uint32'},
        {text: 'Int8', value: 'int8'},
        {text: 'Int16', value: 'int16'},
        {text: 'Int32', value: 'int32'}
      ]
    }
  },
  methods: {
    async save () {
      if (!this.validationName()) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Full name'), 'Error')
        return
      }
      let copy = JSON.parse(JSON.stringify(this.editItem))
      let DHCPv6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let optionDef = {
        'is_test_only': true,
        'loop_count_timeout': 35,
        'config': {}
      }
      if (this.isEdit) {
        for (let el of this.optionDef) {
          if (this.editItem.numOptionDef === el.numOptionDef) {
            el.name = this.editItem.name
            el.code = Number(this.editItem.code)
            el.space = this.editItem.space
            el['record-types'] = this.editItem['record-types']
            el.encapsulate = this.editItem.encapsulate
            el.array = this.editItem.array
            el.type = this.editItem.type
          }
        }
        DHCPv6.arguments.Dhcp6['option-def'] = this.optionDef
      } else {
        this.editItem.code = Number(this.editItem.code)
        DHCPv6.arguments.Dhcp6['option-def'].push(this.editItem)
      }
      for (let el of DHCPv6.arguments.Dhcp6['option-def']) {
        delete el.numOptionDef
      }
      optionDef.config = DHCPv6.arguments
      await this.$store.dispatch('Settings/SAVE_DHCPV6', optionDef).then(response => {
        if (response.data.result === 0) {
          optionDef.is_test_only = false
          let response = this.$store.dispatch('Settings/SAVE_DHCPV6', optionDef)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
              this.$refs.modalEditOptionDef.hide()
              this.$root.$emit('makeToasts')
            }
          })
        } else {
          this.editItem = copy
          this.$root.$emit('makeToasts', 'danger', response.data.text, 'Error')
        }
      })
    },
    validationName () {
      if (this.editItem.name.length === 0) {
        return false
      }
      let strArray = this.editItem.name.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_/'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.editItem.name.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DHCPv6/optionDef/editModal.vue